<form [formGroup]="form">
  <ng-container *ngIf="!design_pattern">
    <mat-form-field floatLabel="always" [ngClass]="{'label-overflow':label_overflow}">
      <label [title]="label" *ngIf="label_block" class="m-0 html-label" [innerHtml]="label"></label>
      <mat-label [title]="label" *ngIf="!label_block &&label" [innerHtml]="label"></mat-label>
      <mat-label *ngIf="!label"></mat-label>
      <input matInput [matDatepicker]="picker" [min]="minValue" [max]="maxValue" [formControl]="date"
        [placeholder]="placeholder" (dateInput)="addEvent($event)" (dateChange)="addEvent($event)" [required]="required"
        (click)="openPicker(!disabled)" readonly>
      <span class="pointer" matSuffix *ngIf="form.get(controlName).value && !required && !disabled"
        (click)="removeDate($event)">
        <i class="fa fa-times"></i>
      </span>
      <!-- <ng-container *ngIf="!disabled"> -->
        <mat-datepicker-toggle matSuffix [for]="picker" *ngIf="!disabled"></mat-datepicker-toggle>
        <mat-datepicker [startView]="start_view||'month'" [startAt]="startAt" #picker></mat-datepicker>
      <!-- </ng-container> -->

      <mat-error *ngIf="form.controls[controlName].hasError('required');else maxvalue">
        Field is mandatory
        <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
      </mat-error>
      <ng-template #maxvalue>
        <mat-error *ngIf="date.hasError('matDatepickerMax');else minvalue">
          Value must be lesser than {{maxValue | UtcToLocalTime | date: 'd-MMM-yyyy'}}
        </mat-error>
      </ng-template>
      <ng-template #minvalue>
        <mat-error *ngIf="date.hasError('matDatepickerMin')">
          Value must be greater than {{minValue | UtcToLocalTime | date: 'd-MMM-yyyy'}}
        </mat-error>
      </ng-template>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="design_pattern==2">
    <div class="row">
      <!-- <label class="col-md-3 col-form-label req title" *ngIf="label" [ngClass]="{'req':required}"
        [innerHtml]="label | HTMLFormatter">
        {{label | translate}}
      </label> -->

      <div class="col-md-12">

        <input class="form-control control-check" [matDatepicker]="picker" [min]="minValue" [max]="maxValue"
          [formControl]="date" [placeholder]="placeholder" (dateInput)="addEvent($event)"
          [ngClass]="{ 'invalid': (form.get([controlName]).touched && form.get([controlName]).errors) }"
          (dateChange)="addEvent($event)" (click)="openPicker(1)" readonly autocomplete="false">
        <span class="input-group-addon" style="    padding: 0px !important;
        border-left: none;
        position: absolute;
        z-index: 2;
        right: 12px;
        top: 0px;">
          <span *ngIf="form && form.get(controlName) && form.get(controlName).value && !required"
            (click)="removeDate($event)">
            <i class="fa fa-times"></i>
          </span>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        </span>
        <mat-datepicker #picker></mat-datepicker>
        <div class="error"
          *ngIf="form.get([controlName]).touched && form.get([controlName]).hasError('required');else maxvalue">
          {{placeholder}} {{"ERROR.is_required" |translate}}
          <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
        </div>
        <ng-template #maxvalue>
          <div *ngIf="form.get([controlName]).hasError('max');else minvalue">
            {{"ERROR.max_value" |translate}} {{maxValue |UtcToLocalTime | date: 'dd-MMM-yyyy'}}
          </div>
        </ng-template>
        <ng-template #minvalue>
          <div *ngIf="form.get([controlName]).hasError('min')">
            {{"ERROR.min_value" |translate}} {{minValue |UtcToLocalTime | date: 'dd-MMM-yyyy'}}
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <!-- <mat-form-field floatLabel='always'>
    <mat-label>{{label}}</mat-label> -->
  <!-- <input type="date" [formControlName]="controlName" [placeholder]="placeholder" value="form.get('controlName').value"> -->
  <!-- <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field> -->
</form>
